import script from "./UserSupervisorRemoveModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserSupervisorRemoveModal.vue?vue&type=script&lang=ts&setup=true"

import "./UserSupervisorRemoveModal.vue?vue&type=style&index=0&id=65fc79c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65fc79c2"]])

export default __exports__